import { compose, createStore } from 'redux';
import rootReducer from './Reducers';

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?? compose;
const Store = createStore(rootReducer, composeEnhancers());

export type RootState = ReturnType<typeof rootReducer>;
export default Store;
